var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelemedicinaImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.01729 16H20.0928V5H4.01729V16ZM13.0598 18V20H17.0787V22H7.03145V20H11.0503V18H3.00454C2.8726 17.9992 2.74212 17.9725 2.62057 17.9215C2.49902 17.8704 2.38879 17.7959 2.2962 17.7024C2.20361 17.6088 2.13048 17.498 2.081 17.3763C2.03152 17.2546 2.00666 17.1243 2.00785 16.993V4.007C2.00785 3.451 2.465 3 3.00454 3H21.1056C21.6562 3 22.1023 3.449 22.1023 4.007V16.993C22.1023 17.549 21.6451 18 21.1056 18H13.0598V18Z",
    fill: "#115896"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelemedicinaImg);
export default __webpack_public_path__ + "static/media/telemedicinaImg.1c415d42a5014963428c8d0062930c9c.svg";
export { ForwardRef as ReactComponent };